import React, { forwardRef } from 'react';

interface EyeFullProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const EyeFull = forwardRef<HTMLElement, EyeFullProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-eye ${classes || ''}`} style={style}></i>
  );
});

EyeFull.displayName = 'EyeFull';